import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isHiylloIcon } from "@hiyllo/icons";
import React from "react";
export const Icon = React.memo(function Icon(props) {
    if (isHiylloIcon(props.icon)) {
        const Icon = props.icon;
        return _jsx(Icon, { color: props.color ?? '#ffffff', width: props.width ?? 15 });
    }
    return _jsx(FontAwesomeIcon, { icon: props.icon });
});
